import { render, staticRenderFns } from "./manterElaboracao.vue?vue&type=template&id=7797dd78&scoped=true"
import script from "./manterElaboracao.vue?vue&type=script&lang=js"
export * from "./manterElaboracao.vue?vue&type=script&lang=js"
import style0 from "./manterElaboracao.vue?vue&type=style&index=0&id=7797dd78&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7797dd78",
  null
  
)

export default component.exports